import { render, staticRenderFns } from "./changeLog.vue?vue&type=template&id=6309a9ab&scoped=true&"
import script from "./changeLog.vue?vue&type=script&lang=ts&"
export * from "./changeLog.vue?vue&type=script&lang=ts&"
import style0 from "./changeLog.vue?vue&type=style&index=0&id=6309a9ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6309a9ab",
  null
  
)

export default component.exports